import './SuccessOrderCarpenter.scss';
import { FiSubHeaderService } from './../../components/FiSubHeader/FiSubHeaderService';
import { Component } from '../../components/Component';
import { FiCart } from '../../services/Cart';
import * as angular from 'angular';

@Component({
    controllerAs: 'vm',
    template: require('./SuccessOrderCarpenter.html'),
    bindings: {
    }
})
export class SuccessOrderCarpenter {
    static $inject = [
        'fiSubHeaderService',
        'fiCart',
        '$http',
    ];


    constructor(
        private fshs: FiSubHeaderService,
        private cart: FiCart,
        private $http: angular.IHttpService,
    ) {
        /* */
    }

    order = [];

    $onInit() {

        this.fshs.subHeaderIsHidden = true;
        this.order = JSON.parse(localStorage.getItem('orderInfo'));

        this.order = [];
        localStorage.removeItem('orderInfo');


        // Here we were sending email from oldFunctionToDelete()
    }


    oldFuntionToDelete() {
        this.$http.post("https://www.fitit.lt/db/carpenter.php", { 

            order_id: this.order['order_id']

        }, { headers: {'Content-Type': 'application/json'} })
            .then((response: any) => {

                this.$http.post("https://www.fitit.lt/db/success-new-carpenter.php", { 
            
                    name:this.order['name'],
                    email: this.order['email'],
                    order_id: this.order['order_id']

                }, { headers: {'Content-Type': 'application/json'} })
                    .then(function (response) { 
                        this.order = [];
                        localStorage.removeItem('orderInfo');
                });

        });
    }
}
